export default (conclusionPage) => {
    const { title, hubText, hubLink, dashboardText, dashboardLink, impactText, impactLink, imageText } = conclusionPage;
    const colour = 'print.primary.7';
    const markdown = {
        link: { colour, weight: 'bold', style: 'italic' }
    };
    return {
        position: 'content',
        title: {
            text: title,
            font: { colour }
        },
        subtitle: {
            text: 'Picture the possibilites... Healthy Albertans. Healthy Communities. Together.',
            font: { weight: 'bold', size: 'md' },
            mb: 10
        },
        hubText: {
            markdown,
            text: `${hubText} Visit Healthier Communities Hub at ${hubLink}.`,
            mb: 10
        },
        dashboardText: {
            markdown,
            text: `${dashboardText} Visit the dashboard at ${dashboardLink}.`,
            mb: 10
        },
        impactText: {
            markdown,
            text: `${impactText} See the potential impact at ${impactLink}.`,
            mb: 10
        },
        imageText: {
            text: imageText
        },
        conclusionImg: {
            src: 'AHSPuzzleImage.svg',
            x: 'w-1-1/4',
            w: 400,
            h: 393
        }
    };
};
